export default {
  customOnDropHandler: () => {
    return Promise.resolve({ handled: false });
  },
};
